"use client";

import React from "react";
import { ArrowRight } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function ATasteOfOurStory() {
  const {
    ref: imageRef,
    isVisible: isImageVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: contentRef,
    isVisible: isContentVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="221575" id="the-wellness-philosophy" className="bg-background text-foreground relative overflow-hidden py-20 lg:py-32">
      <div className="container mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 items-start gap-12 lg:grid-cols-12 lg:gap-16">
          {}
          <div ref={imageRef} className={`lg:col-span-5 transition-all duration-1000 ease-out ${isImageVisible ? "translate-y-0 opacity-100" : "translate-y-12 opacity-0"}`}>
            <div className="relative aspect-[3/4] w-full overflow-hidden rounded-3xl shadow-md">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1672390/img/botanical_arrangement_spa.png" alt="Serene botanical arrangement at Portland Wellness Spa" className="h-full w-full object-cover" loading="lazy" src="https://portlandwellnessspa.com/wp-content/uploads/2026/05/Screenshot-2026-05-18-at-6.39.webp" />
              <img className="absolute inset-0 ring-1 ring-inset ring-primary/5 rounded-3xl" src="https://portlandwellnessspa.com/wp-content/uploads/2026/05/botanical_arrangement_spa.png" alt="" />
              {}
              <div className="absolute -bottom-6 -left-6 -z-10 h-full w-full rounded-3xl bg-secondary/40"></div>
            </div>
          </div>

          {}
          <div ref={contentRef} className={`lg:col-span-7 lg:pt-16 xl:pt-24 transition-all duration-1000 delay-200 ease-out ${isContentVisible ? "translate-y-0 opacity-100" : "translate-y-12 opacity-0"}`}>
            <div className="flex flex-col items-start space-y-8">
              

              <h2 className="font-default text-4xl font-medium leading-tight text-primary md:text-5xl lg:text-6xl">
                The Wellness Philosophy
              </h2>

              <div className="space-y-6 text-lg leading-relaxed text-foreground md:text-xl font-default">
                <p className="!font-sans">At Portland Wellness Spa, we believe that genuine relief starts with skilled hands and a space where you can actually let your guard down. We've built an environment that is warm and professional without the intimidating atmosphere of a high-end spa. Good body treatments should be accessible to everyone.</p>
                <p className="!font-sans">We take our work seriously. Every treatment is delivered with intention and care, tailored to what your body needs that day. Whether you're managing chronic tension, recovering from physical strain, or simply need to step away and reset, our staff is focused on delivering results you can feel.</p>
                <p className="!font-sans">This is a place built for real people who work hard and need real relief. Come in and experience the difference that dedicated, hands-on treatment can make.</p>
              </div>

              <div className="pt-4">
                
              </div>
            </div>
          </div>
        </div>
      </div>
      {}
      <div className="absolute bottom-8 right-8 opacity-10 pointer-events-none">
        <svg width="120" height="120" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1" className="text-primary">
          <path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z" />
        </svg>
      </div>
    </section>;
}